"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.EditableImageController = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

// based off: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/drawImage
var EditableImageController = /*#__PURE__*/function () {
  (0, _createClass2.default)(EditableImageController, [{
    key: "coverScaleFactor",
    get: function get() {
      var widthRatio = this.canvasWidth / this.image.width;
      var heightRatio = this.canvasHeight / this.image.height;
      return Math.max(widthRatio, heightRatio);
    }
  }, {
    key: "coverWidth",
    get: function get() {
      return this.coverScaleFactor * this.image.width;
    }
  }, {
    key: "coverHeight",
    get: function get() {
      return this.coverScaleFactor * this.image.height;
    }
  }]);

  function EditableImageController(image, canvasWidth, canvasHeight, startOffsetX, startOffsetY) {
    var _this = this;

    (0, _classCallCheck2.default)(this, EditableImageController);
    this.image = image;
    this.canvasWidth = canvasWidth;
    this.canvasHeight = canvasHeight;
    this.originalOffsetX = void 0;
    this.originalOffsetY = void 0;
    this.currentOffsetX = void 0;
    this.currentOffsetY = void 0;
    this.scalePercentage = void 0;

    this.GetCanvasOutput = function () {
      return {
        offsetX: _this.currentOffsetX,
        offsetY: _this.currentOffsetY,
        sourceWidth: _this.image.width,
        sourceHeight: _this.image.height,
        destinationWidth: _this.coverWidth * (_this.scalePercentage / 100),
        destinationHeight: _this.coverHeight * (_this.scalePercentage / 100)
      };
    };

    this.Scale = function (percentage) {
      var x = _this.canvasWidth / 2;
      var y = _this.canvasHeight / 2;

      _this.scaleFromCoordinates(percentage, x, y);
    };

    this.SetScale = function (percentage) {
      var scaleAmount = percentage / _this.scalePercentage * 100;
      var x = _this.canvasWidth / 2;
      var y = _this.canvasHeight / 2;

      _this.scaleFromCoordinates(scaleAmount, x, y);
    };

    this.Translate = function (translateX, translateY) {
      _this.setOffset(_this.currentOffsetX + translateX, _this.currentOffsetY + translateY);
    };

    this.SetDragPosition = function (imageDragReferenceX, imageDragReferenceY, x, y) {
      _this.setOffset(imageDragReferenceX + x, imageDragReferenceY + y);
    };

    this.GetBlobImage = function (mimeType) {
      var scaleFactor = _this.coverScaleFactor * (_this.scalePercentage / 100);
      var tmpCanvasOffsetX = _this.currentOffsetX / scaleFactor;
      var tmpCanvasOffsetY = _this.currentOffsetY / scaleFactor;
      var tmpCanvas = document.createElement('canvas');
      tmpCanvas.width = _this.canvasWidth / scaleFactor;
      tmpCanvas.height = _this.canvasHeight / scaleFactor;
      var context = tmpCanvas.getContext('2d');
      context.drawImage(_this.image, tmpCanvasOffsetX, tmpCanvasOffsetY, _this.image.width, _this.image.height);
      return new _promise.default(function (resolve) {
        var dataUri = tmpCanvas.toBlob(function (blob) {
          resolve(blob);
        }, mimeType, 1);
        tmpCanvas.remove();
        return dataUri;
      });
    };

    this.scaleFromCoordinates = function (percentage, x, y) {
      var percentageAsDecimal = percentage / 100;
      var diffX = (_this.currentOffsetX - x) * percentageAsDecimal;
      var diffY = (_this.currentOffsetY - y) * percentageAsDecimal;
      _this.scalePercentage = _this.scalePercentage * percentageAsDecimal;
      var scaledX = x + diffX;
      var scaledY = x + diffY;

      _this.setOffset(scaledX, scaledY);
    };

    this.setOffset = function (offsetX, offsetY) {
      var destinationWidth = _this.coverWidth * (_this.scalePercentage / 100);
      var destinationHeight = _this.coverHeight * (_this.scalePercentage / 100);
      var outOfBoundsMinX = offsetX > 0;
      var outOfBoundsMaxX = destinationWidth + offsetX < _this.canvasWidth;
      var outOfBoundsMinY = offsetY > 0;
      var outOfBoundsMaxY = destinationHeight + offsetY < _this.canvasHeight;
      var isOutOfBounds = outOfBoundsMinX || outOfBoundsMaxX || outOfBoundsMinY || outOfBoundsMaxY;

      if (isOutOfBounds) {
        if (outOfBoundsMinX) {
          offsetX = 0;
        }

        if (outOfBoundsMaxX) {
          offsetX = _this.canvasWidth - destinationWidth;
        }

        if (outOfBoundsMinY) {
          offsetY = 0;
        }

        if (outOfBoundsMaxY) {
          offsetY = _this.canvasHeight - destinationHeight;
        }
      }

      _this.currentOffsetX = offsetX;
      _this.currentOffsetY = offsetY;
    };

    this.originalOffsetX = startOffsetX;
    this.originalOffsetY = startOffsetY;
    this.currentOffsetX = this.originalOffsetX;
    this.currentOffsetY = this.originalOffsetY;
    this.scalePercentage = 100;
  }

  return EditableImageController;
}();

exports.EditableImageController = EditableImageController;